import { RATE_PLANS_DATA_FETCHER_ACTIONS } from '../../actions/ratePlansActions';
import { prepareRatePlanData, getMissingMockApiData } from "../../helpers/ratePlanHelper";

const ratePlansReducer = (state ={
    isLoading: true,
    fetchingDetails : false,
}, action) => {
    switch(action.type) {
        case RATE_PLANS_DATA_FETCHER_ACTIONS.FETCH_SUCCESS:
          let ratePlanData = [];
          let isMissingData = true;
          let apiResponse = action.payload.apiResponse;

          //If data is not present, or if actual dataPoints are less than expectedDataPoints by threshold amount, then show error
          if(apiResponse && apiResponse.comparedRates && apiResponse.comparedRates.length && 
            (apiResponse.comparedRates[0].expectedDataPoints - apiResponse.comparedRates[0].dataPoints <= action.payload.dataPointsThreshold)) {
            ratePlanData = prepareRatePlanData(apiResponse.comparedRates);
            isMissingData = false;
          } else {
            ratePlanData = getMissingMockApiData();
          }

          if(!ratePlanData.ratePlanData || !ratePlanData.ratePlanData.length) {
            ratePlanData = getMissingMockApiData();
          }
          state = {
            ...state,
            rateplansResponse: apiResponse,
            rateplansList: ratePlanData.ratePlanData,
            candidateStyle: ratePlanData.minHeightCandidate,
            isLoading: false,
            isMissingData : isMissingData,
          }
          break;
        case RATE_PLANS_DATA_FETCHER_ACTIONS.FETCH_FAILED:
          let data = getMissingMockApiData();
          state = {
            ...state,
            error: true,
            rateplansList: data.ratePlanData,
            candidateStyle: data.minHeightCandidate,
            isLoading: false,
            isMissingData: true,
          }
          break;
        default:
          break;
    }
  return state;
}

export default ratePlansReducer;